const RevenueAgencyPageLangKey = [
	'btn_add_new'
] as const

type IRevenueAgencyPageLangKey = typeof RevenueAgencyPageLangKey[number]

export type IRevenueAgencyPageLang = {
	revenue_agency_page: Record<IRevenueAgencyPageLangKey, string>
}

const langEntries = RevenueAgencyPageLangKey.map(
	(key: IRevenueAgencyPageLangKey) => [key, `revenue_agency_page.${key}`]
)

const langObj: Record<IRevenueAgencyPageLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_AGENCY_PAGE_LANG_KEY: IRevenueAgencyPageLang = {
	revenue_agency_page: langObj
}
